import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { AdminUserService } from 'app/services/admin/user.service';
import { CustomerService } from 'app/services/customer.service';

@Component({
  selector: 'app-custom-navbar',
  templateUrl: './custom-navbar.component.html',
  styleUrls: ['./custom-navbar.component.scss']
})
export class CustomNavbarComponent implements OnInit {
  isShow = false;
  isAdminShow = false;
  isMenuOpen = false;
  openDropdown: 'settings' | null = null;

  constructor(
    private _loginService: CustomerService,
    private _adminUserService: AdminUserService,
    private _changeDetectorRef: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this._loginService.isLogin.subscribe((res) => {
      this.isShow = res;
      this._changeDetectorRef.markForCheck();
    });

    this._adminUserService.isLogin.subscribe((resAd) => {
      this.isAdminShow = resAd;
      this._changeDetectorRef.markForCheck();
    });
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;

    if (!this.isMenuOpen) {
      this.openDropdown = null;
    }
  }

  closeMenu(): void {
    if (this.isDesktopView()) {
      return;
    }

    this.isMenuOpen = false;
    this.openDropdown = null;
  }

  toggleDropdown(menu: 'settings', event: Event): void {
    if (this.isDesktopView()) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.openDropdown = this.openDropdown === menu ? null : menu;
  }

  isDropdownOpen(menu: 'settings'): boolean {
    return this.openDropdown === menu;
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    if (this.isDesktopView()) {
      this.isMenuOpen = false;
      this.openDropdown = null;
    }
  }

  private isDesktopView(): boolean {
    return typeof window !== 'undefined' && window.innerWidth >= 992;
  }
}
